module.exports = __webpack_public_path__ + "media/images/Etoiles-c3d4e4f46d5190c13377f2c3f8f9262d.svg";